var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"match-height"},[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('v-card',[_c('v-card-title',[_vm._v("Search Client")]),_c('v-card-text',[_c('search-client')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }